import React from 'react';
import Icon from '../Icon';
import { translate } from '../../Services/translation';
import { VIPPS_BUTTON_TYPE } from '../../constants';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { performVippsLoginAction, performVippsRegisterAction } from '../../Actions/VippsLogin.action';
import { useDispatch } from 'react-redux';

type ButtonType = "login" | "register"

interface VippsButtonProps {
    className?: string
    type: ButtonType
}

const VippsButton = ({ className, type }: VippsButtonProps) => {
    const { isLoading } = useTypedSelector((state) => state.login);
    const isButtonLoading = isLoading;

    const dispatch = useDispatch();
    const performVippsLogin = (e?: any) => {
        if (e) {
            e.preventDefault();
        }
        dispatch(performVippsLoginAction(e));
    };

    const performVippsRegister = (e?: any) => {
        if (e) {
            e.preventDefault();
        }
        dispatch(performVippsRegisterAction(e));
    };

    return (
        <button
            className={`btn btn--large btn--vipps ${className}`}
            onClick={type === VIPPS_BUTTON_TYPE.Login ? performVippsLogin : performVippsRegister}
        >
            {isButtonLoading ? (
                <span>
                    {translate('general.loading')}
                </span>
            ) : (
                <>
                    <span>
                        {type === VIPPS_BUTTON_TYPE.Login
                            ? translate("vipps.login-btn-text")
                            : translate("vipps.register-btn-text")}
                    </span>
                    <Icon name="vipps-white" className="!w-36 !h-36" />
                </>
            )}
        </button>
    );
};

export default VippsButton;